import { faShuffle } from "@fortawesome/pro-regular-svg-icons/faShuffle";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconRandom: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <><MprcIconFa {...props} icon={faShuffle} />&nbsp;</>;
};
